import React from "react"
import { Helmet } from "react-helmet"
import { Navbar } from "../../components"
import styled from "styled-components"
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';
import "../../assets/css/fonts.css"
import "../../assets/css/override.css"

// Create a dark theme
const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
  },
});

const StyledLayout = styled.div`
  width: 100%;
  background: #121212;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

const StyledMain = styled.main`
  height: calc(100vh - 64px); // Material UI AppBar height
  display: flex;
  flex-direction: column;
  flex: 1;
`

export default function Layout({ children }) {
  return (
    <React.Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Streaming overview</title>
        <link rel="canonical" href="https://www.google.com" />
      </Helmet>
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <StyledLayout>
          <Navbar />
          <StyledMain>
            <Box sx={{ flex: 1, p: 2 }}>
              {children}
            </Box>
          </StyledMain>
        </StyledLayout>
      </ThemeProvider>
    </React.Fragment>
  )
}